import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
import useHexColor from '../../../hooks/use-hex-color'

const ColorSwatch = ({enabledVariants, isBundle = false}) => {
    const {resolveHexColor, getHexFromObject} = useHexColor()

    const colorContent = (
        <>
            {enabledVariants?.map((variant, idx) => {
                const normalizedColor = resolveHexColor(
                    getHexFromObject(variant?.swatch),
                    getHexFromObject(variant),
                    variant?.c_hexColor,
                    variant?.c_hexColour,
                    variant?.hexColor,
                    variant?.hexColour,
                )
                const displayColors = normalizedColor ? normalizedColor.split(',').slice(0, 2) : []

                if (displayColors.length === 0) {
                    return null
                }

                return (
                    <React.Fragment key={variant?.id || idx}>
                        {displayColors.length === 1 ? (
                            <Flex
                                key={`${variant?.id || idx}-0`}
                                flexDir="column"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                width={remCalc(6)}
                                minWidth={remCalc(6)}
                                flexShrink={0}
                                height={remCalc(12)}
                                borderRadius="full"
                                backgroundColor={displayColors[0]}
                            />
                        ) : (
                            <Flex
                                key={`${variant?.id || idx}-split`}
                                flexDir="column"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                width={remCalc(6)}
                                minWidth={remCalc(6)}
                                flexShrink={0}
                                height={remCalc(12)}
                                borderRadius="full"
                                overflow="hidden"
                            >
                                <Flex
                                    width="100%"
                                    height="50%"
                                    backgroundColor={displayColors[0]}
                                />
                                <Flex
                                    width="100%"
                                    height="50%"
                                    backgroundColor={displayColors[1]}
                                />
                            </Flex>
                        )}
                    </React.Fragment>
                )
            })}
        </>
    )

    // if isBundle is true, render only the colors without the Flex wrapper
    if (isBundle) {
        return colorContent
    }

    // Otherwise, render with the external Flex wrapper
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            gap="xxxsmall.base"
            paddingY="xxxsmall-1.base"
            paddingX="xxsmall-1.base"
        >
            {colorContent}
        </Flex>
    )
}

ColorSwatch.propTypes = {
    enabledVariants: PropTypes.array,
    isBundle: PropTypes.bool,
}
export default ColorSwatch
